import { useContext } from 'react'
import { ReservationIdContext } from './reservation-id.context'

export function useReservationId() {
  return useContext(ReservationIdContext)
}
